<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12" v-if="content">
        <exercise-logic-multiple
          exCollection="successPillarsExCollection"
          refCollection=""
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          @modifyEx="onModifyEx"
          @loadedRef="onLoadedRef"
          :doc="doc"
          :shared="false"
          :projectShared="false"
          :pid="true"
          :eid="$route.params.eid"
          :synced="false"
          :saveState="saveState"
        >
          <template slot-scope="{ saveExercise }">
            <v-stepper v-model="e1">
              <v-stepper-items>
                <!-- Step 1 -->
                <v-stepper-content step="1">
                  <v-row>
                    <v-col cols="4" class="mb-4">
                      <h2
                        class="headline"
                        v-text="content.exercise_success.title"
                      ></h2>
                    </v-col>

                    <v-col cols="8" class="">
                      <p
                        v-for="(item, index) in content.exercise_success
                          .description"
                        :key="index"
                        v-text="item"
                      />
                    </v-col>
                  </v-row>
                  <!-- loop through questions from language file -->
                  <div v-if="doc">
                    <v-row
                      v-for="row in content.exercise_success.questions"
                      :key="row.title"
                    >
                      <v-col cols="12" offset="0">
                        <h2 class="text-h5">{{ row.title }}</h2>
                      </v-col>

                      <v-col cols="6">
                        <v-card height="100%">
                          <v-card-text>
                            <unit-items-icon
                              v-model="doc.matrix[row.short.model]"
                              :limit="10"
                              :name="row.short.name"
                              :title="row.short.title"
                              color="amber"
                              bgColor="#494949"
                              svg="Do.svg"
                              size="contain"
                              @autosave="doAutoSave"
                            >
                            </unit-items-icon>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-card height="100%">
                          <v-card-text>
                            <unit-items-icon
                              v-model="doc.matrix[row.long.model]"
                              :limit="20"
                              :name="row.long.name"
                              num=""
                              :title="row.long.title"
                              description=""
                              color="amber"
                              bgColor="#494949"
                              size="contain"
                              svg="Thought.svg"
                              @autosave="doAutoSave"
                            >
                            </unit-items-icon>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <bottom-navigation
                    :save="true"
                    :next="false"
                    :prev="false"
                    :gridView="false"
                    :gridToggle="false"
                    @save="saveExercise(true)"
                    @prev="prevStep"
                    @next="saveExercise(false)"
                  >
                  </bottom-navigation>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-if="content" v-model="dialog" max-width="800">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title class="headline">{{
          content.exercise_success.saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-title>Add note</v-card-title>

        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit note</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card light v-else>
        <v-card-title class="headline">{{
          content.exercise_success.saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-btn
            color="white"
            top
            right
            absolute
            class="black--text"
            @click="dialog = false"
          >
            Close
          </v-btn>

          <v-btn
            class="grey lighten-3"
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";

import { UnitItemsIcon } from "@/components/units";

export default {
  name: "UserSuccessPillars",
  data() {
    return {
      e1: 1,
      content: null,
      saveState: false,
      autoSave: true,
      exercises: null,
      refs: null,
      dialog: false,
      dialogMode: "add",
      allItems: null,
      listName: "",
      doc: {
        title: "",
        matrix: {
          q1: [],
          q2: [],
          q3: [],
          q4: [],
          q5: [],
          q6: [],
          q7: [],
          q8: [],
          q9: [],
          q10: [],
          q11: [],
          q12: [],
          q13: [],
          q14: [],
          q15: [],
          q16: [],
          q17: [],
          q18: [],
          q19: [],
          q20: [],
          q21: [],
          q22: [],
          q23: [],
          q24: [],
          q25: [],
          q26: [],
          q27: [],
          q28: [],
          q29: [],
          q30: [],
        },
        list: {},
        listNames: [],
        allItems: [],
        audienceAll: [],
        contentAll: [],
      },
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    UnitItemsIcon,
  },
  watch: {
    // e1(val) {
    //   if (val === 3) {
    //     this.createList();
    //   }
    // },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialogMode = "";
      this.dialog = true;
    },
    onLoadedRef(refs) {
      console.log("loaded refs", refs);
    },
    onLoadedEx(items) {
      console.log("loaded exercises", items);
      if (items) {
        this.mergeArrays(items[0].doc);
      }
    },
    onModifyEx(items) {
      // console.log("modify exercises", items);
      this.exercises = [...items];
    },
    onSavedNext() {
      // this.nextStep();
      this.saveState = false;
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    navigateTo(slug) {
      this.$router.push(
        `/users/project/${this.$route.params.id}/${slug}/shared`
      );
    },
    mergeArrays(arr) {
      console.log("merge arrays", arr);
      Object.entries(arr).forEach(([outerKey, value]) => {
        if (typeof value !== "object") {
          this.doc[outerKey] = value;
        } else {
          Object.entries(value).forEach(([key, value]) => {
            this.doc[outerKey][key] = value;
          });
        }
      });
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    doAutoSave() {
      if (this.autoSave) {
        console.log("doing autosave");
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
